import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
document.addEventListener('DOMContentLoaded', function() {
     
    // 初始化Swiper
    var swiper1 = new Swiper(".section2 .swiper", {
        direction: "vertical",
        mousewheel: {
            enabled: true,
            releaseOnEdges: true, // 滚动到边缘时释放鼠标滚轮控制
            forceToAxis: true,    // 只允许纵向滚动
            invert: false,
            sensitivity: 1,
            eventsTarget: 'container'
        },
    });
});


$(".section6 ul li").hover(function() {
    $(this).addClass("active1");
},function() {
    $(".section6 ul li").removeClass('active1');
})